import { axiosClient } from "./axios";

export interface HistoryResponse {
  message: string;
  code: string;
  data: OrderHistory[];
}

export interface OrderHistory {
  uuid: string;
  order_id: string;
  payment_status: string;
  payment_ref: string;
  amount: string;
  payment_channel: string;
  payment_channel_id: string;
  created_at: string;
}

export interface OrderHistoryDetailResponse {
  message: string;
  code: string;
  data: OrderHistoryDetail;
}

export interface OrderHistoryDetail {
  order_id: string;
  payment_status: string;
  payment_ref: string;
  total_amount: string;
  payment_channel: string;
  created_at: string;
  customer_name: string;
  details: OrderDetail[];
}

export interface OrderDetail {
  msisdn: string;
  package_quota: string;
  voice_quota: string;
  day_quota: string;
  price: string;
  area: string;
  imge: string;
  created_at: string;
  package_name: string;
}

export const getHistories = async (cusId: string) => {
  const res = await axiosClient.get<HistoryResponse>("histories", {
    params: {
      cus_id: cusId,
    },
  });

  return res.data;
};

export const getHistoryDetails = async (
  orderUuid: string,
  channelId: string
) => {
  const res = await axiosClient.get<OrderHistoryDetailResponse>("history", {
    params: {
      order_id: orderUuid,
      payment_channel_id: channelId,
    },
  });

  return res.data;
};
